import React from 'react';

type Props = {
  size?: 'small' | 'medium' | 'large';
  color?: 'pear' | 'midnight';
  className?: string;
};

export default function SpinnerSolid({ size = 'small', color = 'pear', className }: Props) {
  const sizeClasses = {
    small: 'w-4 h-4',
    medium: 'w-6 h-6',
    large: 'w-8 h-8',
  };

  const colorClasses = {
    pear: 'text-pear-900',
    midnight: 'text-midnight-500',
  };

  return (
    <img
      src='/spinner.svg'
      className={`animate-spin ${sizeClasses[size]} ${colorClasses[color]} ${className || ''}`}
      alt='Loading…'
    />
  );
}
